// extracted by mini-css-extract-plugin
export var deleteModal = "_ev-0";